var _defs, _rect, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaymentsFast(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1200,
    height: 700,
    viewBox: "0 0 1200 700",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1200,
    y2: 700,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7FFF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFF5E3"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1200,
    height: 700,
    rx: 48,
    fill: "url(#bg)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.92
  }, /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 190,
    width: 880,
    height: 320,
    rx: 44,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 250,
    width: 380,
    height: 44,
    rx: 22,
    fill: "#F3F5FA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 320,
    width: 620,
    height: 22,
    rx: 11,
    fill: "#E6EAF3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 360,
    width: 520,
    height: 22,
    rx: 11,
    fill: "#E6EAF3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 400,
    width: 460,
    height: 22,
    rx: 11,
    fill: "#E6EAF3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 920,
    cy: 350,
    r: 92,
    fill: "#FCB402"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M883 350h74",
    stroke: "#FFFFFF",
    strokeWidth: 20,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M920 313v74",
    stroke: "#FFFFFF",
    strokeWidth: 20,
    strokeLinecap: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190 160c60-70 150-110 260-110",
    stroke: "#6CCFB1",
    strokeWidth: 18,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210 560c80 60 170 90 300 90",
    stroke: "#6CCFB1",
    strokeWidth: 18,
    strokeLinecap: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentsFast);
export default __webpack_public_path__ + "static/media/payments-fast.d09cf7e9c512c45b80f0575a7b6d0fba.svg";
export { ForwardRef as ReactComponent };